/*
 * 4mypet Roof Type Upgrade — variant map.
 * Auto-generated from Shopify product ID: 15769685819766
 * Generated: 2026-08-17
 */

window.FMP_ROOF_VARIANTS = {
  "0": 58037951725942,
  "9": 58473683583350,
  "12": 58473683616118,
  "14": 58473683648886,
  "18": 58473683681654,
  "21": 58473683714422,
  "25": 58473683747190,
  "26": 58473683779958,
  "27": 58473683812726,
  "30": 58473683845494,
  "39": 58473683878262,
  "40": 58473683911030,
  "45": 58473683943798,
  "53": 58473683976566,
  "58": 58473684009334,
  "59": 58473684042102,
  "60": 58473684074870,
  "62": 58473684107638,
  "63": 58473684140406,
  "64": 58473684173174,
  "65": 58473684205942,
  "67": 58473684238710,
  "68": 58473684271478,
  "72": 58473684304246,
  "73": 58473684337014,
  "76": 58473684369782,
  "82": 58473684402550,
  "84": 58473684435318,
  "90": 58473684468086,
  "96": 58473685746038,
  "99": 58473684500854,
  "100": 58473684533622,
  "106": 58473684566390,
  "108": 58473684599158,
  "113": 58473684631926,
  "118": 58473684664694,
  "121": 58473684697462,
  "124": 58473684730230,
  "129": 58473685778806,
  "140": 58473684762998,
  "144": 58473684795766,
  "150": 58473684828534,
  "159": 58473684861302,
  "162": 58473684894070,
  "170": 58473684926838,
  "177": 58473684959606,
  "180": 58473684992374,
  "186": 58473685025142,
  "198": 58473685057910,
  "199": 58473685090678,
  "204": 58473685123446,
  "210": 58473685156214,
  "212": 58473685188982,
  "216": 58473685221750,
  "219": 58473685254518,
  "242": 58473685287286,
  "248": 58473685320054,
  "255": 58473685352822,
  "279": 58473685385590,
  "285": 58473685418358,
  "289": 58473685451126,
  "312": 58473685483894,
  "339": 58473685516662,
  "350": 58473685549430,
  "352": 58473685582198,
  "405": 58473685614966,
  "450": 58473685647734,
  "556": 58473685680502,
  "676": 58473685713270,
};
